export const isProviderPhoneValid = (fields, values) => {
    if ((fields === null || fields === void 0 ? void 0 : fields.name) === "providerPhone") {
        if (!values.match(/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/))
            return false;
        return values;
    }
    else {
        return true;
    }
};
